const state = {
    cart: {
        items: [],
        count: 0,
    }
}

const mutations = {
    alterQty(state, params) {
        let found = getters.getCartItem(state, params);
        if (!found.item) {
            return;
        }
        found.item.quantity = params.quantity || 1;
    },
    addItem(state, params) {
        let found = getters.getCartItem(state, params)
        if (found.item) {
            found.item.quantity += params.quantity || 1;
            return;
        }
        if (params.quantity === undefined) {
            params.quantity = 1;
        }
        state.cart.items.push(params);
    },
    delItem(state, params) {
        let found = getters.getCartItem(state, params)
        if (!found.item) {
            return;
        }
        if (params.quantity === undefined) {
            params.quantity = found.item.quantity;
        }
        found.item.quantity -= params.quantity;
        if (found.item.quantity < 1) {
            state.cart.items.splice(found, 1)
        }
    },
    setCount(state, count) {
        state.count = count;
    },
    empty(state) {
        state.cart.items = [];
    },
}

const actions = {
    cartAdd(context, params) {
        context.commit('addItem', params);
    },
    cartDel(context, params) {
        context.commit('delItem', params);
    },
    cartQty(context, params) {
        context.commit('alterQty', params);
    },
    cartReset(context) {
        context.commit('empty');
    },
}

const getters = {
    getCartCount: state => {
        let count = 0;
        state.cart.items.forEach(item => count += item.quantity);
        return count;
    },
    getCart: state => {
        return state.cart.items;
    },
    getCartItem: (state, params) => {
        let index = state.cart.items.findIndex(i => i.id === params.id);
        return {
            item: state.cart.items[index],
            index,
        }
    },
}

const ShoppingCart = {
    state,
    mutations,
    actions,
    getters
}

export default ShoppingCart;
